// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import get from 'lodash/get'
import moment from 'moment'
import { Redirect, withRouter } from 'react-router-dom'

const dateNow = (format?: string): string => moment().format(format)

const getRedirectPath = (match: any, date: string, paramName: string): string => {
  const dateRegex = new RegExp(`:${paramName}[^/]*`)

  return match.path.indexOf(':' + paramName) !== -1
    ? match.path.replace(dateRegex, date)
    : match.path.replace(/\/{1}$/g, '') + '/' + date
}

type DecoratorProps = {
  match: any
}

type DecoratorState = {
  date: string
}

type DecoratorConfig = {
  dateFormat?: string
  paramName?: string
}

const withDate =
  (config?: DecoratorConfig) =>
  (WrappedComponent: any): any => {
    const { dateFormat = 'YYYY-MM-DD', paramName = 'date' } = config || {}

    class Decorator extends React.PureComponent<DecoratorProps, DecoratorState> {
      state = {
        date: get(this.props, `match.params.${paramName}`, dateNow(dateFormat)),
      }

      onDateChange = (date) => {
        this.setState({ date })
      }

      render() {
        const { match } = this.props
        const { date } = this.state

        if (date && date !== get(match, `params.${paramName}`)) {
          return <Redirect to={getRedirectPath(match, date, paramName)} />
        }

        return <WrappedComponent date={date} dateFormat={dateFormat} onDateChange={this.onDateChange} {...this.props} />
      }
    }

    return withRouter(Decorator)
  }

export type WithDateProps = {
  date: string
  dateFormat: string
  onDateChange: (...props: any) => any
}

export default withDate
